import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { ISettingEntry } from "@faire/web-api--source/indigofair/settings/ISettingEntry";
import { setting } from "./setting";
export function configuration(schema) {
    return setting(_object_spread({
        type: ISettingEntry.SettingType.CONFIGURATION
    }, schema));
}
